export compose from './compose';
export deletePost from './delete';
export edit from './edit';
export fetch from './fetch';
export rate from './rate';
export report from './report';
export respond from './respond';
export lock from './lock';
export pin from './pin';



// WEBPACK FOOTER //
// ./~/virgo/src/actions/dataActionsCreator/posts/index.js